// src/utils/parsers/fileUtils.js

export const parseNumber = (str) => {
    if (typeof str === 'number') return str;
    if (!str) return 0;
    
    // Sayıyı temizle ve parse et
    const cleaned = str.toString()
      .replace(/[^\d,.-]/g, '') // Sadece sayı, virgül, nokta ve eksi işareti kal
      .replace(/\./g, '') // Binlik ayracı noktaları kaldır
      .replace(',', '.'); // Virgülü noktaya çevir
    
    return parseFloat(cleaned) || 0;
  };
  
  export const cleanSymbol = (symbol) => {
    if (!symbol) return '';
    
    // Remove HTML tags and special characters
    return symbol
      .replace(/<[^>]*>/g, '') // HTML taglerini kaldır
      .replace(/[^A-Z]/g, '') // Sadece büyük harfleri tut
      .substring(0, 5); // Maksimum 5 karakter
  };
  
  export const convertTurkishToEnglish = (text) => {
    return text
      .replace(/Ğ/g, 'G')
      .replace(/Ü/g, 'U')
      .replace(/Ş/g, 'S')
      .replace(/İ/g, 'I')
      .replace(/Ö/g, 'O')
      .replace(/Ç/g, 'C')
      .replace(/ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/ş/g, 's')
      .replace(/ı/g, 'i')
      .replace(/ö/g, 'o')
      .replace(/ç/g, 'c');
  };
  
  export const standardizeStockData = (stock) => {
    try {
      console.log('Standardizing stock data:', stock);
      
      const standardized = {
        symbol: cleanSymbol(stock.symbol),
        shares: parseNumber(stock.shares),
        price: parseNumber(stock.price),
        total: 0, // Önce 0'a set edip sonra hesaplayacağız
        cost: parseNumber(stock.cost),
        profitLoss: parseNumber(stock.profitLoss)
      };
  
      // Toplam değeri hesapla (eğer gelen veri hatalıysa)
      if (standardized.total === 0) {
        standardized.total = standardized.price * standardized.shares;
      }
  
      console.log('Standardized result:', standardized);
      return standardized;
    } catch (error) {
      console.error('Error in standardizeStockData:', error);
      throw error;
    }
  };